
import { useEffect, useRef, useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter, useParams } from 'react-router-dom'

import { Box, Flex } from '@chakra-ui/react'
import {
  changeDsrPageDisplay,
  setNewDsrDraftCurrentPage,
} from '../../digital-sales-room/actions/dsr-actions'
import DsrProspectSideMenu from './DsrProspectSideMenu'
import RenderSubpageContent from '../components/RenderSubpageContent'
import { manageDsrUrlTags } from '../../global/helpers/url-tag-helpers'
import useChangeSubpageDisplay from '../../global/hooks/change-subpage-display';


// Note: Render Dsr Content for DRAFT states
const RenderProspectDsrContent = ({
  changeDsrPageDisplay,
  selectedDisplaySubpage,
  pagesLocalState,
  selectedDisplayPageId,
  dsrPropertiesRedux,
  headerMenuHeight,
  isReadingMode,
  dsrBrandingOptions,
  applyBranding,
}) => {

  const { pDsrId } = useParams()
  const initRef = useRef(false);
  const { handleSelectSubpage, clickCount } = useChangeSubpageDisplay();


  useEffect(() => {
    if ((!initRef.current && pagesLocalState)) {
      const visiblePages = pagesLocalState.filter(page => page.displayPage === true)

      if (visiblePages.length > 0) {
        changeDsrPageDisplay(visiblePages[0].pageId)
      } else {
        changeDsrPageDisplay('no-visible-pages')
      }

      // TODO: Implement GA for Prospect DSR
      initRef.current = true
    }
  }, [selectedDisplayPageId, pagesLocalState, changeDsrPageDisplay])


  const [extraHeaderLayoutOffset, setExtraHeaderLayoutOffset] = useState(false)

  useEffect(() => {
    if (dsrPropertiesRedux.logoDisplayOption) {
      if (dsrPropertiesRedux.logoDisplayOption === "default") {
        !!extraHeaderLayoutOffset && setExtraHeaderLayoutOffset(false)
      } else {
        !extraHeaderLayoutOffset && setExtraHeaderLayoutOffset(true)
      }
    }
  }, [dsrPropertiesRedux.logoDisplayOption]);


  useEffect(() => {
    const handleUrlChange = () => {
      const viewpage = manageDsrUrlTags("viewpage");
      viewpage && handleSelectSubpage("pg__" + viewpage, "")

    };

    window.addEventListener("url-changed", handleUrlChange);

    return () => {
      window.removeEventListener("url-changed", handleUrlChange);
    };

  }, []);


  return (
    <Flex className='dsr-content__section' justifyContent='flex-start'>
      <Flex className='dsr-content__container' height='100%'>
        <Flex direction="column" align="flex-start" w='100%' minHeight="40em">

          <Flex direction="row" align="flex-start" width="100%" height='100%'>
            <Flex display={['none', 'none', 'flex', 'flex']} position='sticky' top={headerMenuHeight} bg="white">
              <DsrProspectSideMenu
                pageArray={pagesLocalState}
                selectedDisplayPageId={selectedDisplayPageId}
                handleSelectSubpage={handleSelectSubpage}
                headerMenuHeight={headerMenuHeight}
                dsrBrandingOptions={dsrBrandingOptions}
                applyBranding={applyBranding}
                extraHeaderLayoutOffset={extraHeaderLayoutOffset}
              />
            </Flex>

            <Flex
              direction={['column', 'row']}
              justify="center"
              flexWrap="wrap"
              width="100%"
              bg='#F4F4F4'
              height='100%'
              pb='3em'
            >

              <Box

                key={'page-view-' + clickCount}
                className="dsr-content__middle-column-container fade-in"
                transition="max-width 0.75s ease-in-out"
                maxWidth={isReadingMode ? '1200px' : ['100%', '100%', '800px', '800px']}
                pt={extraHeaderLayoutOffset && '1em'}
                px={isReadingMode ? "5em" : "1em"} >
                <RenderSubpageContent
                  pageArray={pagesLocalState}
                  selectedDisplaySubpage={selectedDisplaySubpage}
                  selectedDisplayPageId={selectedDisplayPageId}
                  pDsrId={pDsrId}
                  dsrProperties={dsrPropertiesRedux}
                  handleSelectSubpage={handleSelectSubpage}
                />

              </Box>
            </Flex>
            {/* // If any, use below section to house dynamically rendered components depending on user journey */}

          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

const mapStateToProps = (state) => ({
  selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
  draftDsrCurrentPageRedux: state.dsrFeedContent.currentPage,
  dsrPropertiesRedux: state.draftDsrProperties.properties,
  selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
  dsrBrandingOptions: state.dsrBrandingOptions.results,
  applyBranding: state.dsrApplyBranding.results,
  isReadingMode: state.isReadingMode.results
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeDsrPageDisplay,
      setNewDsrDraftCurrentPage
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RenderProspectDsrContent))
